import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import { PROXY_URL_LANGUAGE_VARIANTS } from 'academy-common-lib/utils/url';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import styled from 'foundations-theming/utils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { appendHubsContent } from '../../../../utils/urls';
import usageTracker from '../../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkStyle = styled.div.withConfig({
  displayName: "LanguageLinks__LinkStyle",
  componentId: "sc-1mjhjyv-0"
})(() => ({
  ul: {
    justifyContent: 'center !important'
  }
}));
const LinkHovered = styled.span.withConfig({
  displayName: "LanguageLinks__LinkHovered",
  componentId: "sc-1mjhjyv-1"
})(({
  theme
}) => ({
  '&:hover': {
    color: theme.color['do-not-use-flint']
  }
}));
const LanguageLinks = () => {
  const handleClick = languageName => {
    usageTracker.track('navInteraction', {
      action: 'footer-language-link-click',
      value: languageName
    });
  };
  return /*#__PURE__*/_jsx(TFlex, {
    inlineSize: "100%",
    justifyContent: "center",
    textAlign: "center",
    wrap: "wrap",
    children: /*#__PURE__*/_jsx(LinkStyle, {
      children: /*#__PURE__*/_jsx(List, {
        inline: true,
        marginBlock: "900",
        marginInline: "auto",
        children: supportedPublicLanguages.map(lang => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: appendHubsContent(`https://${PROXY_URL_LANGUAGE_VARIANTS[lang]}/`, LanguageNames[lang]),
            lang: lang,
            onClick: () => handleClick(LanguageNames[lang]),
            use: "unstyled",
            children: /*#__PURE__*/_jsx(Paragraph, {
              color: "do-not-use-battleship",
              margin: "0",
              paddingBlock: "200",
              paddingInline: "200",
              textAlign: "center",
              typography: "heading-100",
              children: /*#__PURE__*/_jsx(LinkHovered, {
                children: LanguageNames[lang]
              })
            })
          })
        }, lang))
      })
    })
  });
};
export default LanguageLinks;